Namespace 'Monitoring.Reports.Publications.Content'

class Monitoring.Reports.Publications.Content.SentimentView extends Backbone.View

  className: 'content-section content-sentiment'
  template: JST['backbone/templates/monitoring/reports/publications/content/sentiment']

  initialize: (@options = {}, @header) ->

    # just set @options

  render_twitter: ->
    content = @options.contents[0]
    user = content.user
    type = content.type
    content_ids = _.map(@options.contents, (content) -> content.content_id)
    document_ids = _.map(@options.contents, (content) -> content.id)
    include_comment_replies = @header.include_comment_replies()

    params =
      date_since:              @header.getDateFrom()
      date_until:              @header.getDateTo()
      dimension:               @header.getDimension()
      document_ids:            document_ids
      content_ids:             document_ids
      type:                    type
      include_comment_replies: include_comment_replies
      user:                    user

    $.ajax
      type: 'post'
      url: '/monitoring/reports/publications/twitter_report_view'
      data: params
      success: @renderResults
      error: @fail

  render: ->

    content = @options.contents[0]
    user = content.user
    type = content.type
    content_ids = _.map(@options.contents, (content) -> content.content_id)
    document_ids = _.map(@options.contents, (content) -> content.id)
    include_comment_replies = @header.include_comment_replies()
    params =
      date_since:               @header.getDateFrom()
      date_until:               @header.getDateTo()
      dimension:                @header.getDimension()
      document_ids:             document_ids
      content_ids:              content_ids
      type:                     type
      include_comment_replies:  include_comment_replies
      user:                     user

    $.ajax
      type: 'post'
      url: '/monitoring/reports/publications/sentiment'
      data: params
      success: @renderResults
      error: @fail

  renderResults: (data) =>
    @$el.addClass('rendered')
    @$el.html(@template({ metrics: data }))
    @trigger('rendered')

  fail: =>

    @trigger('fail')
